export default "__VITE_ASSET__59f25d66__"